import React from "react";
import { Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import { SUB_DIRCTORY } from "../app_config";

const RoleBasedRedirect = () => {
  const userRole = useSelector((state) => state.user.Roles);
  let redirectPath = "/";

  if (userRole.includes("SuperAdmin")) {
    redirectPath =  "/business-owner";
  } else if (userRole.includes("ParkingManager")) {
    redirectPath = "/parking-booking";
  } else if (userRole.includes("BusinessOffice")) {
    redirectPath = "/charge-back-customer";
  } else {
    redirectPath = "/dashboard";
  }

  return <Redirect to={SUB_DIRCTORY + redirectPath} />;
};

export default RoleBasedRedirect;
